<div class="grid">
	<div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
		<p-tag icon="pi cm-alert" [value]="('BOARD_USER_EXPORT_NEW_WARNING' | translate)" severity="warning"></p-tag>
	</div>
</div>
<div class="grid mt-0">
	<div [class]="col6ResponsiveButtonLayout('left')">
		<p-button id="exportDataDevice" label="{{ 'EXPORT_DATA_DEVICE' | translate }}" (click)="exportData()"
			[disabled]="taskRunning || !online" icon="pi cm-cloud-sync" [rounded]="false" [text]="true" severity="warning"
			styleClass="font-bold border-yellow-600">
		</p-button>
	</div>
	<div [class]="col6ResponsiveButtonLayout('right')">
	</div>
</div>
<div *ngIf="acRbeSyncing">
	<div class="flex align-items-center justify-content-center w-full pb-8 mb-8">
		<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
	</div>
</div>
<p-accordion *ngIf="!acRbeSyncing">
	<app-import-export-list></app-import-export-list>
</p-accordion>